//#region Imports

import { Component, Injector, ViewEncapsulation, ViewChild, OnInit, EventEmitter, Output, Input, OnDestroy } from '@angular/core';

import {Observable, Subject, of} from 'rxjs';
import {takeUntil, catchError, debounceTime} from 'rxjs/operators';

import { appModuleAnimation } from '@axilla/axilla-shared';

import { AppComponentBase } from '@shared/common/app-component-base';
import {CombineViewService} from '@app/webshop/shared/services/combine-view.service';
import { ViewMode } from '../../models';
import {BasePermissionDefinition} from '@shared/permission/base-permission-definition';
import {SelectItem} from 'primeng/api';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
//#endregion Imports

@Component({
    selector: 'app-combine-view-switcher',
    templateUrl: './combine-view-switcher.component.html',
    styleUrls: ['./combine-view-switcher.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class CombineViewSwitcherComponent extends AppComponentBase implements OnInit, OnDestroy {
    @Output()
    onSort: EventEmitter<any> = new EventEmitter();

    protected readonly BasePermissionDefinition = BasePermissionDefinition;

    @Input()
    hideSearch = true;

    @Input()
    showAdditionalFilters = false;
    @Input()
    hideSorting = false;

    @Input()
    isSortingAvailable = false;
    //Sorting option
    @Input()
    sortOptions: SelectItem[];

    @Output()
    searchAndLoadData: EventEmitter<any> = new EventEmitter();

    showOnlyInTrunk = false;

    sortKey = '';

    searchForm: UntypedFormGroup;
    query = '';

    get viewMode(): ViewMode {
        return this._combineViewService.currentMode;
    }

    get isTableView(): boolean {
        return this._combineViewService.isTableView;
    }

    get isTileView(): boolean {
        return this._combineViewService.isTileView;
    }
    get isListView(): boolean {
        return this._combineViewService.isListView;
    }

    constructor(
        injector: Injector,
        private _combineViewService: CombineViewService
    ) {
        super(injector);

        // Initialize the observable to track the view mode
        this.viewMode$ = this._combineViewService.viewMode$;
    }

    layout: any;

    private viewMode$: Observable<ViewMode>;

    protected readonly ViewMode = ViewMode;

    protected readonly destroy$ = new Subject<void>();

    ngOnInit(): void {
        this.viewMode$
            .pipe(
                takeUntil(this.destroy$) // Automatically unsubscribes when destroy$ emits
            )
            .subscribe((viewMode) => {
            //console.log('Current View Mode:', ViewMode[viewMode]);
        });

        this._initsearchForm();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private _initsearchForm() {
        this.searchForm = new UntypedFormGroup({
            filter: new UntypedFormControl(null),
        });

        this.searchForm.get('filter').valueChanges.pipe(
            debounceTime(300),
            catchError(error => of(`Caught an error: ${error.message}`))
        ).subscribe({
            next: query => this.search(query),
            error: err => `Error: ${err.message}`,
            complete: () => console.log('Completed')
        });
    }

    onSearchClick(): void {
        const query = this.searchForm.get('filter').value;
    }

    search(query?: any) {
        //this.spinnerService.show();

        this.query = query || this.searchForm.get('filter').value;
        this.webshopService.globalSearchFilter = this.query;
        this.searchAndLoadData.emit();
    }

    clearInput() {
        this.searchForm.get('filter').setValue('');
        this.searchForm.get('filter').updateValueAndValidity();
    }

    changeViewMode(mode: ViewMode): void {
        this._combineViewService.changeViewMode(mode);
    }

    onSortChange(event) {
        let value = event.value;

        this.onSort.emit(value);
    }

    onShowOnlyInTrunkChange(event: Event) {
        const checked = (event.target as HTMLInputElement).checked;
        this._combineViewService.setShowOnlyInTrunk(checked);
    }
}
